import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

const MfaFactorSelectStyles = makeStyles()((theme: Theme) => ({
  subtitle: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#1A1A1E',
    marginTop: '8px',
  },
  factorsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginTop: '16px',
    marginBottom: '24px',
  },
  factorCard: {
    border: '1px solid #E0E0E0',
    borderRadius: '8px',
    transition: 'border-color 0.2s, box-shadow 0.2s',
    '&:hover': {
      borderColor: '#F13C00',
      boxShadow: '0 2px 8px rgba(241, 60, 0, 0.15)',
    },
  },
  cardContent: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 20px',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: '#FFF5F2',
    color: '#F13C00',
    marginRight: '16px',
    flexShrink: 0,
  },
  textContainer: {
    flex: 1,
  },
  factorName: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#1A1A1E',
    marginBottom: '4px',
  },
  factorDescription: {
    fontSize: '14px',
    color: '#666',
  },
}))

export default MfaFactorSelectStyles
